import { forwardRef } from 'react';

import type { ContainedButtonProps } from '@types';
import { cn } from '@utils';

import { BaseButton } from '.';

export const OutlinedButton = forwardRef<HTMLButtonElement, ContainedButtonProps>(
  ({ disabled = false, adornment, onClick, className, ...props }, ref) => {
    return (
      <BaseButton
        ref={ref}
        className={cn(
          'px-3.5 py-3 rounded-2xl',
          'ring-1 ring-theme-primary-main text-theme-primary-main bg-transparent',
          'hover:bg-blue-50 hover:bg-opacity-50',
          'disabled:ring-theme-border-default disabled:text-gray-400/30 disabled:bg-gray-200/30',
          className,
        )}
        onClick={onClick}
        disabled={disabled}
        adornment={adornment}
        {...props}
      />
    );
  },
);
